import Mobilization from '@/models/mobilization.model'
import mobilizationRepository from '@/repositories/mobilizationRepository'
import { ActionContext } from 'vuex'

interface FetchMonthPayload {
  year: number
  month: number
}

interface MobilizationState {
  selectedDay: Date | undefined
  networkState: string | undefined
  mobilizationDetails: Mobilization[]
  monthlyMobilizations: Mobilization[]
}

type MobilizationActionContext = ActionContext<MobilizationState, unknown>

const mobilizationModule = {
  namespaced: true,
  state: (): MobilizationState => ({
    selectedDay: undefined,
    mobilizationDetails: [],
    monthlyMobilizations: [],
    networkState: undefined
  }),
  getters: {
    getSelectedDay: (state: MobilizationState): Date | undefined => {
      return state.selectedDay
    },
    getMobilizationDetails: (state: MobilizationState) => state.mobilizationDetails,
    getMonthlyMobilizations: (state: MobilizationState) => state.monthlyMobilizations,
    getNetworkState: (state: MobilizationState) => state.networkState
  },
  mutations: {
    SET_SELECTED_DAY (state: MobilizationState, day: Date) {
      state.selectedDay = day
    },
    SET_MOBILIZATION_DETAILS (state: MobilizationState, details: Mobilization[]) {
      state.mobilizationDetails = details
    },
    SET_MONTHLY_MOBILIZATION (state: MobilizationState, mobilizations: Mobilization[]) {
      state.monthlyMobilizations = mobilizations
    },
    SET_OFFLINE (state: MobilizationState, networkState: string) {
      state.networkState = networkState
    }
  },
  actions: {
    async setSelectedDayAndFetchData ({ commit, dispatch }: MobilizationActionContext, day: Date) {
      commit('SET_SELECTED_DAY', day)
      dispatch('fetchMobilizationDataForDay')
    },
    async fetchMobilizationDataForDay ({ state, commit }: MobilizationActionContext) {
      if (!state.selectedDay) {
        throw new Error('No selected day')
      }
      const data = await mobilizationRepository.getMobilizationsForDay(state.selectedDay)
      if (data.state === 'success') {
        commit('SET_MOBILIZATION_DETAILS', data.data)
      }
      commit('SET_OFFLINE', data.state)
    },
    async fetchMobilizationsForMonth ({ commit }: MobilizationActionContext, { year, month }: FetchMonthPayload) {
      const data = await mobilizationRepository.getMobilizationsForMonth(year, month)
      if (data.state === 'success') {
        commit('SET_MONTHLY_MOBILIZATION', data.data)
      }
      commit('SET_OFFLINE', data.state)
    }
  }
}

export default mobilizationModule
